import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import EditVehicleLayer from "../../components/vehicles/EditVehicleLayer";


const EditVehiclePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Edit Vehicle" />

        {/* AddUserLayer */}
        <EditVehicleLayer />


      </MasterLayout>
    </>
  );
};

export default EditVehiclePage;
